import { render, staticRenderFns } from "./PaymentOrderDownload.vue?vue&type=template&id=6a0a58f7&scoped=true"
import script from "./PaymentOrderDownload.vue?vue&type=script&lang=js"
export * from "./PaymentOrderDownload.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderDownload.vue?vue&type=style&index=0&id=6a0a58f7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a58f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0a58f7')) {
      api.createRecord('6a0a58f7', component.options)
    } else {
      api.reload('6a0a58f7', component.options)
    }
    module.hot.accept("./PaymentOrderDownload.vue?vue&type=template&id=6a0a58f7&scoped=true", function () {
      api.rerender('6a0a58f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentOrder/PaymentOrderDownload.vue"
export default component.exports